import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { User } from '#types/index';
import { getAuthToken } from '@utils/cookie';

interface UserState {
  currentUser: User | null;
  token: string | null;
  isAuthenticated: boolean;
  authEpoch: number;
}

function getInitialToken(): string | null {
  // Cookie is the identity actually sent to the server.
  return getAuthToken();
}

const initialState: UserState = {
  currentUser: null,
  token: getInitialToken(),
  isAuthenticated: !!getInitialToken(),
  authEpoch: 0,
};

const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setUser: (state, action: PayloadAction<User>) => {
      state.currentUser = action.payload;
      state.isAuthenticated = true;
    },
    setToken: (state, action: PayloadAction<string>) => {
      if (state.token !== action.payload) {
        state.authEpoch += 1;
        state.currentUser = null;
      }
      state.token = action.payload;
      state.isAuthenticated = true;
      localStorage.setItem('token', action.payload);
    },
    logout: (state) => {
      state.authEpoch += 1;
      if (typeof sessionStorage !== 'undefined') {
        Object.keys(sessionStorage).filter(key => key.startsWith('consultation:auto:')).forEach(key => sessionStorage.removeItem(key));
      }
      state.currentUser = null;
      state.token = null;
      state.isAuthenticated = false;
      if (typeof localStorage !== 'undefined') localStorage.removeItem('token');
    },
  },
});

export const { setUser, setToken, logout } = userSlice.actions;
export default userSlice.reducer;

